import { ChartData, ChartOptions } from 'chart.js'
import { Radar } from 'react-chartjs-2'
import ChartsHelper from './ChartsHelper'

interface Props {
    data: ChartData<'radar', number[], unknown>
    options?: ChartOptions<'radar'>
    isLoading?: boolean
}

const RadarChart = ({ data, options, isLoading }: Props) => {
    let chartData = data
    let chartOptions = options

    if (isLoading) {
        chartData = {
            datasets: [
                { data: Array(7).fill(0).map(() => Math.random() * 11) }
            ],
            labels: Array(7).fill(0).map(() => '______')
        }

        chartOptions = options
    }

    ChartsHelper.applyColors(chartData.datasets as any, isLoading)

    return (
        <Radar
            data={chartData}
            width='100%'
            height='100%'
            options={chartOptions ?? RadarChartDefaultOptions}
        />
    )
}

export default RadarChart
export const RadarChartDefaultOptions: ChartOptions<'radar'> = {
    maintainAspectRatio: false,
    plugins: {
        datalabels: { display: false },
        tooltip: { callbacks: {} },
        legend: { display: false }
    },
    scales: {
        r: {
            ticks: {
                backdropColor: 'transparent'
            }
        }
    }
}
